import request from "../../utils/request";
import { Result } from "../../models/general";

export interface FileUploadSettingsView {
  profilePhotoMaxSizeMB: number;
  userDocumentMaxSizeMB: number;
  leaveAttachmentMaxSizeMB: number;
  claimAttachmentMaxSizeMB: number;
  clockingPhotoMaxSizeMB: number;
  bugReportAttachmentMaxSizeMB: number;
  companyLogoMaxSizeMB: number;
  payslipBrandingLogoMaxSizeMB: number;
  notificationImageMaxSizeMB: number;
  batchImportMaxSizeMB: number;
  matchAttachmentMaxSizeMB: number;
  lastModifiedBy: string | null;
  lastModifiedAt: string | null;
}

export interface FileUploadSettingsPublicView {
  profilePhotoMaxSizeMB: number;
  userDocumentMaxSizeMB: number;
  leaveAttachmentMaxSizeMB: number;
  claimAttachmentMaxSizeMB: number;
  clockingPhotoMaxSizeMB: number;
  bugReportAttachmentMaxSizeMB: number;
  companyLogoMaxSizeMB: number;
  payslipBrandingLogoMaxSizeMB: number;
  notificationImageMaxSizeMB: number;
  batchImportMaxSizeMB: number;
  matchAttachmentMaxSizeMB: number;
}

export interface FileUploadSettingsInput {
  profilePhotoMaxSizeMB: number;
  userDocumentMaxSizeMB: number;
  leaveAttachmentMaxSizeMB: number;
  claimAttachmentMaxSizeMB: number;
  clockingPhotoMaxSizeMB: number;
  bugReportAttachmentMaxSizeMB: number;
  companyLogoMaxSizeMB: number;
  payslipBrandingLogoMaxSizeMB: number;
  notificationImageMaxSizeMB: number;
  batchImportMaxSizeMB: number;
  matchAttachmentMaxSizeMB: number;
}

export async function getFileUploadSettings() {
  const response = await request.get<Result<FileUploadSettingsView>>("FileUploadSettings");
  return response.data;
}

export async function updateFileUploadSettings(input: FileUploadSettingsInput) {
  const response = await request.put<Result<FileUploadSettingsView>>("FileUploadSettings", input);
  return response.data;
}

export async function getFileUploadPublicSettings() {
  const response = await request.get<Result<FileUploadSettingsPublicView>>("FileUploadSettings/Public");
  return response.data;
}
